// extracted by mini-css-extract-plugin
module.exports = {"rightContent":"rightContent-_vMHdJ2a"};